import React, { useEffect, useState, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { Page, NotifyModal, SearchBar, BootstrapMultiSelect } from 'components';
import { Forms, Equipments } from './components';
import AddAlarm from '../../components/AddAlarm/AddAlarm';
import AddRotation from '../../components/AddRotation/AddRotation';

import Header from '../../components/Header/Header';
import Reload from 'components/Reload/Reload';

import { updateEquipmentFields } from 'api/equipmentsService';

import {
  Tab,
  Col,
  Row,
  Tabs,
  Card,
  Form,
  Modal,
  Button,
  FloatingLabel,
  DropdownButton,
  Dropdown,
} from 'react-bootstrap';

import ApiMServer from 'services/ApiMServer';
import ApiGServer from 'services/ApiGServer';
import { RENTAL_PLANS } from 'constants/planOptions';

import './UnitsDetail.css';
import Dryers from './components/Dryers';
import DryersTable from './components/DryersTable';

const UnitsDetail = (props) => {
  const _id = useParams().id;

  const history = useHistory();

  const data = JSON.parse(localStorage.getItem('userData'));
  if (data?.permission?.units?.read !== true) {
    window.location.replace('/home');
  }
  const idUser = data?._id;
  const email = data?.email;

  const [openDialogActivation, setOpenDialogActivation] = useState(false);
  const [showModelSelectModal, setShowModelSelectModal] = useState(false);
  const [selectedModels, setSelectedModels] = useState([]);
  const [openDialogPlanRental, setOpenDialogPlanRental] = useState(false);
  const [openDialogPlanOwner, setOpenDialogPlanOwner] = useState(false);

  const [daystoactivate, setDaystoactivate] = useState('');
  const [equipments, setEquipments] = useState([]);
  const [equipmentsAll, setEquipmentsAll] = useState([]);
  const [serialsnumbers, setSerialsNumbers] = useState([]);
  const [id, setId] = useState('');
  const [permission, setPermission] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ "message": '', "type": '' });
  const [selectedEquipments, setSelectedEquipments] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [chave, setChave] = useState('equipamentos');
  const [unidades, setUnidades] = useState([]);
  const [rentalEquipments, setRentalEquipments] = useState([])
  const [ownerEquipments, setOwnerEquipments] = useState([])

  // Estado para detecção de tema
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    const bodyHasDarkClass = document.body.classList.contains('dark-theme');
    const htmlHasDarkClass = document.documentElement.classList.contains('dark-theme');

    if (savedTheme) {
      return savedTheme;
    }
    return bodyHasDarkClass || htmlHasDarkClass ? 'dark' : 'light';
  });

  const [allEmails, setAllEmails] = useState([]);
  const [searchData, setSearchData] = useState('');

  const handleSearchData = (e) => {
    setSearchData(e.target.value)
  };

  const [loading, setLoading] = useState(true);

  const [type, setType] = useState({ "color": "", "status": "" });
  const [modalShow, setModalShow] = useState(false);

  // Estados para o modal de confirmação de batch actions
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [batchAction, setBatchAction] = useState({ field: '', value: false, label: '' });

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "orange", "status": msg })
    setModalShow(true)
  }

  const [units, setUnits] = useState({
    typeCompany: false,
    crossCheck: false,
    equipments: [],
    localEquipament: [],
    units: [],
    id: '',
    name: '',
    cnpj: '',
    ncontract: '',
    fone: '',
    email: '',
    password: '',
    secretOnlyKey: '',
    accessSecretOnlyKey: '',
    dominioEmail: '',
    createdAt: '',
    updatedAt: '',
    restrictAcess: false,
    address: '',
    location: {
      lat: '',
      lng: ''
    }
  });

  const [emails, setEmails] = useState([]);
  const [linkedCooperatives, setLinkedCooperatives] = useState([]);

  // useEffect para detectar mudanças de tema
  useEffect(() => {
    const handleThemeChange = () => {
      const bodyHasDarkClass = document.body.classList.contains('dark-theme');
      const htmlHasDarkClass = document.documentElement.classList.contains('dark-theme');
      const savedTheme = localStorage.getItem('theme');

      let detectedTheme = 'light';

      if (savedTheme) {
        detectedTheme = savedTheme;
      } else if (bodyHasDarkClass || htmlHasDarkClass) {
        detectedTheme = 'dark';
      }

      setTheme(detectedTheme);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          handleThemeChange();
        }
      });
    });

    observer.observe(document.body, { attributes: true });
    observer.observe(document.documentElement, { attributes: true });

    return () => observer.disconnect();
  }, []);

  const [filds, setFilds] = useState({
    scan_face: null,
    full_tracking: null,
  })

  const [batchActionsLoading, setBatchActionsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const { data } = await ApiMServer.get('/users/manager', { "headers": { "id": _id } });
      setEmails(data);
    })();
  }, [_id]);

  const [checkbox, setCheckbox] = useState({
    simt: true,
    semt: true,
    bitm: true,
    cpmt: true,
    eemt: true,
    esmr: true,
    fard: true,
    cton: true,
    mufl: true,
    prar: true,
    sbag: true,
  });

  const handleChangeModeAll = (mode) => {
    let validate = window.confirm('Confirma essa ação para todos os equipamentos desta empresa?')
    if (validate) {
      let list = equipments.map(item => item.serialnumber);
      (async () => {
        await ApiGServer.post(`/equipment/updatemodegroup`, { list, "mode": mode })
        getEquipments();
      })()
    }
    return;
  }


  const handleCloseUpdateActivation = () => {
    setOpenDialogActivation(false);
  };

  // Funções para ações em lote (scan_face e full_tracking)
  const prevValues = useRef({
    scan_face: null,
    full_tracking: null,
  });

  useEffect(() => {
    const hasScanFaceChanged = filds.scan_face !== prevValues.current.scan_face && filds.scan_face !== null;
    const hasFullTrackingChanged = filds.full_tracking !== prevValues.current.full_tracking && filds.full_tracking !== null;

    if (hasScanFaceChanged || hasFullTrackingChanged) {
      // Atualiza os valores anteriores
      prevValues.current = {
        scan_face: filds.scan_face,
        full_tracking: filds.full_tracking,
      };

      updateEquipmentsFields(); // Chama a função apenas se algum dos dois mudou de null para um valor
    }
  }, [filds.scan_face, filds.full_tracking]);

  const updateEquipmentsFields = async () => {
    let serials = equipments.map(equip => equip.serialnumber);
    setBatchActionsLoading(true);

    // Criar objeto com apenas os campos que foram alterados (não null/undefined)
    const fieldsToUpdate = {};

    if (filds.scan_face !== null && filds.scan_face !== undefined) {
      fieldsToUpdate.scan_face = filds.scan_face;
    }

    if (filds.full_tracking !== null && filds.full_tracking !== undefined) {
      fieldsToUpdate.full_tracking = filds.full_tracking;
    }

    // Verificar se há pelo menos um campo para atualizar
    if (Object.keys(fieldsToUpdate).length === 0) {
      setBatchActionsLoading(false);
      handleAlertModalError("Nenhum campo foi selecionado para atualização!");
      return;
    }

    console.log('Campos a serem atualizados:', fieldsToUpdate);

    try {
      const result = await updateEquipmentFields(serials, fieldsToUpdate);
      handleAlertModalSuccess(`Equipamentos atualizados com sucesso! Campos alterados: ${Object.keys(fieldsToUpdate).join(', ')}`);

      // Resetar os campos para null após atualização bem-sucedida
      setFilds({
        scan_face: null,
        full_tracking: null,
      });

      // Resetar também os valores de referência
      prevValues.current = {
        scan_face: null,
        full_tracking: null,
      };

    } catch (error) {
      handleAlertModalError("Erro ao atualizar!");
      console.error('Erro na atualização dos equipamentos:', error);
    } finally {
      setBatchActionsLoading(false);
    }
  }

  const handleAddEquipments = async () => {
    if (!selectedEquipments.length) return;
    const data = await ApiMServer.post('/company/addequipment', { "_id": id, "serialnumber": selectedEquipments })

    if (data.status === 200) {
      setKey(!key);

      for (var i in selectedEquipments) {
        units.equipments.push(selectedEquipments[i]);
      }
      setSelectedEquipments([]);
      getEquipments();
      handleAlertModalSuccess("Adicionado com sucesso!");
    }
    if (data.status === 202) {
      let confirm = window.confirm(`Cadastrado em ${data.data.name}, ir para a empresa?`);
      if (confirm) {
        if (data.data.typeCompany === true) {
          window.location.href = `/cooperatives/${data.data._id}`
        } else {
          window.location.href = `/units/${data.data._id}`
        }
      }
      return
    } else {
      return
    }
  };

  const handleRemoveEquipments = async () => {
    if (!selectedEquipments.length) return;
    if (!window.confirm("Confirma remover?")) {
      return;
    } else {
      try {
        await ApiMServer.post('/company/rmequipment', {
          "_id": id,
          "serialnumber": selectedEquipments
        });
        setKey(!key);
        selectedEquipments.forEach((i) => {
          const index = units.equipments.indexOf(i);
          if (index > -1) {
            units.equipments.splice(index, 1);
          }
        })
        setSelectedEquipments([]);
        getEquipments();
        handleAlertModalSuccess("Removido com sucesso!");
      } catch (error) {
        handleAlertModalError('Falha ao atualizar!');
      }
    }
  } // Fim da função handleRemoveEquipamentos

  const handleDaysChange = (event, field, value) => {
    event.persist && event.persist();
    setDaystoactivate(value);
  };

  useEffect(() => {
    const { id } = props.match.params;
    setId(id);
  }, [props]);

  const normalizeLinkedCooperatives = (payload) => {
    const rawList = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.cooperatives)
        ? payload.cooperatives
        : Array.isArray(payload?.data)
          ? payload.data
          : payload && typeof payload === 'object' && (payload._id || payload.id || payload.name)
            ? [payload]
            : [];

    return rawList
      .map((item) => ({
        _id: String(item?._id || item?.id || ''),
        name: item?.name || item?.nome || String(item?._id || item?.id || ''),
      }))
      .filter((item) => Boolean(item._id || item.name));
  };

  const fetchLinkedCooperatives = async (unitId) => {
    if (!unitId) {
      setLinkedCooperatives([]);
      return;
    }

    try {
      const { data } = await ApiMServer.post('/company/v1/getcooperativebyunit', { unitId });
      setLinkedCooperatives(normalizeLinkedCooperatives(data));
    } catch (error) {
      console.error('Erro ao carregar cooperativas vinculadas à unidade:', error);
      setLinkedCooperatives([]);
    }
  };

  const handleCompanyDetail = async () => {
    try {
      let { data: unit } = await ApiMServer.post(`/company/v1/getcooperativedetail`, { id: _id });
      setUnits(unit);

      const equipmentPromise = unit?.equipments?.length > 0
        ? ApiGServer.post(`/equipment/filter`, { filter: unit.equipments })
        : Promise.resolve(null);

      const [equipmentResponse] = await Promise.all([
        equipmentPromise,
        fetchLinkedCooperatives(_id),
      ]);

      if (equipmentResponse) {
        setEquipments(equipmentResponse.data);
        setEquipmentsAll(equipmentResponse.data);
        handlefilterEquipments(equipmentResponse.data);
        localStorage.setItem("tempEquipments", JSON.stringify(equipmentResponse.data));
      }

      setLoading(false);
    } catch (error) {
      handleAlertModalError('Falha ao carregar detalhes!');
      setLoading(false);
    }
  };

  const handlefilterEquipments = (equipamentos) => {
    const rentalEquipments = equipamentos
      .filter(equip => equip.mode === "RENTAL")
      .map(equip => equip.serialnumber)

    setRentalEquipments(rentalEquipments)

    const ownerEquipments = equipamentos
      .filter(equip => equip.mode === "OWNER")
      .map(equip => equip.serialnumber)
    setOwnerEquipments(ownerEquipments)
  }

  const [planRental, setPlanRental] = useState("");
  const handlePlanChangeRental = (plan) => {
    setOpenDialogPlanRental(true);
    setPlanRental(plan);
  };

  const handleUpdatePlanChangeRental = () => {
    handlePlan(planRental, rentalEquipments);
  };

  const [planOwner, setPlanOwner] = useState("");
  const handlePlanChangeOwner = (plan) => {
    setOpenDialogPlanOwner(true);
    setPlanOwner(plan);
  };

  const handleUpdatePlanChangeOwner = () => {
    handlePlan(planOwner, ownerEquipments);
  };

  const handleCloseDialogPlan = () => {
    setOpenDialogPlanRental(false);
    setOpenDialogPlanOwner(false);
  };

  const handlePlan = async (newPlan, serials) => {
    if (planRental || planOwner) {
      setEquipments((prevEquipments) => {
        const updatedEquipments = prevEquipments.map((equipment) => {
          if (serials.includes(equipment.serialnumber)) {
            return { ...equipment, plan: newPlan };
          }
          return equipment;
        });
        return updatedEquipments;
      });

      try {
        await ApiGServer.post(`/equipment/updateplan`, { filter: serials, plan: newPlan });
        handleAlertModalSuccess("Atualizado com sucesso!");
        handleCloseDialogPlan();
      } catch (error) {
        handleAlertModalError('Falha ao atualizar plano!');
        handleCloseDialogPlan();
      }
    } else {
      return
    }
  };

  useEffect(() => {
    const { permission } = JSON.parse(localStorage.getItem('userData'));
    setPermission(permission?.units?.write);
    handleCompanyDetail();
  }, []);

  const getEquipments = () => {
    (async () => {
      await ApiGServer.post(`/equipment/filter`, { "filter": units.equipments })
        .then((response) => {
          setEquipments(response.data);
          handlefilterEquipments(response.data)
        });
    })();
  };

  const removeEquipment = (serialnumber) => {
    let confirm = window.confirm(`Confirma remover o equipamento ${serialnumber}`);
    if (confirm) {
      (async () => {
        await ApiMServer.post(`/company/rmequipment`, { "_id": id, "serialnumber": serialnumber });
        const index = units.equipments.indexOf(serialnumber);
        if (index > -1) {
          units.equipments.splice(index, 1);
        }
        getEquipments();
      })();
    }
  };

  const updateDaysActivation = async () => {
    setShowModelSelectModal(false);
    setOpenDialogActivation(false);

    if (!daystoactivate) {
      alert('O campo dias para Ativação deve ser preenchido!');
      return;
    }

    let value = parseInt(daystoactivate);
    if (isNaN(value)) {
      alert('O campo dias para Ativação deve ser preenchido com um número inteiro!');
      return;
    }

    if (value < 0 || value > 4095) {
      alert('O número de dias para Ativação deve estar entre 0 e 4095!');
      return;
    }

    // Filtra os equipamentos pelos modelos selecionados
    const serialsToUpdate = equipments
      .filter(eq => selectedModels.includes(eq.serialnumber.split('-')[0]))
      .map(eq => eq.serialnumber);

    if (serialsToUpdate.length === 0) {
      alert('Selecione ao menos um modelo para aplicar a alteração!');
      return;
    }

    try {
      await ApiGServer.post('/equipment/updatedaysactivationCompany', {
        list: serialsToUpdate,
        daystoactivate: Number(daystoactivate).toString(16).toUpperCase()
      });
      getEquipments();
      handleAlertModalSuccess('Atualizado com sucesso!');
    } catch (error) {
      handleAlertModalError('Falha ao atualizar dias de ativação!');
    }
  };

  const getAllEmail = async () => {
    try {
      const { data } = await ApiMServer.get('/user/all-email');
      setAllEmails(data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    (async () => {
      await ApiGServer.get('/equipment/serialsnumber')
        .then((response) => {
          var data = response.data;
          data.sort(function (a, b) {
            return a.split('-')[1] - b.split('-')[1];
          }).sort();
          setSerialsNumbers(data);
        });
    })();

    getAllEmail();

  }, []);

  const handleFieldChange = (event, field, value) => {
    setUnits((values) => ({
      ...values,
      [field]: value
    }));
  };

  const handleCheckBoxdChange = (field, value) => {
    setCheckbox((values) => ({
      ...values,
      [field]: value
    }));
  };


  const updateAddressAndLocation = (newAddress, newLat, newLng) => {
    setUnits(prevUnits => ({
      ...prevUnits,
      address: newAddress,
      location: {
        lat: String(newLat),
        lng: String(newLng)
      }
    }));
  };

  const filterData = () => {
    var fequips = [];

    if (checkbox.simt) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "SIMT"));
    }
    if (checkbox.semt) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "SEMT"));
    }
    if (checkbox.bitm) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "BIMT"));
    }
    if (checkbox.cpmt) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "CPMT"));
    }
    if (checkbox.eemt) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "EEMT"));
    }
    if (checkbox.esmr) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "ESMR"));
    }
    if (checkbox.fard) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "FARD"));
    }
    if (checkbox.cton) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "CTON"));
    }
    if (checkbox.mufl) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "MUFL"));
    }
    if (checkbox.prar) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "PRAR"));
    }
    if (checkbox.sbag) {
      Array.prototype.push.apply(fequips, equipments.filter(e => e.serialnumber.split("-")[0] === "SBAG"));
    }

    return fequips;
  }

  const handleSubmit = async () => {
    let data = units;

    delete data.equipments;
    delete data.createdAt;
    delete data.updatedAt;
    delete data.__v;

    data.idUser = idUser;

    try {
      await Promise.all([
        ApiMServer.post('/company/update', data),
        ApiMServer.post('/company/creategestor', { emails, id: units._id })
      ]);

      handleAlertModalSuccess('Atualizado com sucesso!');
    } catch (error) {
      console.error('Erro ao atualizar:', error);
      handleAlertModalError('Falha ao atualizar os dados. Tente novamente.');
    }
  };

  const handleOpenCompany = async () => {
    try {
      await ApiMServer.post(`/company/addgestor`, { id: _id, emails: email });
      window.open(`${process.env.REACT_APP_SGU}`);
    } catch (error) {
      setAlertMessage({ "message": 'Erro ao direcionar!', "type": 'error' });
    }
  }

  const [key, setKey] = useState(false);
  const [keyTwo, setKeyTwo] = useState(false);

  const handleReport = () => {
    localStorage.setItem("EQUIP_FILTER", JSON.stringify(units.equipments))
    localStorage.setItem("EQUIPMENTS", JSON.stringify(equipments))
    history.push('/relatorio');
  }

  const handleSearchEquipments = () => {
    if (!searchData.trim()) {
      setEquipments(equipmentsAll);
      return;
    }

    const filteredEquipments = equipmentsAll.filter((item) =>
      item?.nameEquipament?.toLowerCase().includes(searchData.toLowerCase()) ||
      item?.serialnumber?.toLowerCase().includes(searchData.toLowerCase())
    );

    setEquipments(filteredEquipments);
  };

  // Funções para o modal de confirmação de batch actions
  const handleBatchActionRequest = (field, value, label) => {
    setBatchAction({ field, value, label });
    setShowBatchModal(true);
  };

  const handleConfirmBatchAction = () => {
    setFilds(prev => ({
      ...prev,
      [batchAction.field]: batchAction.value
    }));
    setShowBatchModal(false);
  };

  const handleCancelBatchAction = () => {
    setShowBatchModal(false);
  };


  /*
  const handleSearchUnits = () => {
    if (!searchData.trim()) {
      setUnitsDetail(unitsDetailAll);
      return;
    }

    const filteredUnits = unitsDetailAll.filter((unit) =>
      unit?.name?.toLowerCase().includes(searchData.toLowerCase()) ||
      unit?.cnpj?.toLowerCase().includes(searchData.toLowerCase())
    );

    setUnitsDetail(filteredUnits);
  };
  */

  const saveSecador = async (dryerData) => {
    dryerData._id = _id;
    try {
      let { data } = await ApiMServer.post(`/company/add-dryer`, dryerData);
      setUnits(data);
      handleAlertModalSuccess("Secador adicionado com sucesso!");
    } catch (error) {
      handleAlertModalError("Erro ao atualizar!");
    }
  }

  const savePositions = async (positionsData) => {
    console.log(positionsData);
    try {
      await ApiGServer.post(`/equipment/update-equipments-list`, positionsData);
      console.log("Posições atualizadas com sucesso!");
    } catch (error) {
      console.error("Erro ao atualizar posições:", error);
    }
  }

  const removeDryer = async (dryerId) => {
    if (!dryerId) {
      handleAlertModalError("Ocorreu um erro: ID do secador ausente.");
      return;
    }

    try {
      const { data: updatedUnits } = await ApiMServer.post(`/company/rm-dryer`, { companyId: _id, dryerId });

      setUnits(updatedUnits);

      handleAlertModalSuccess("Secador removido com sucesso!");

    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Falha na comunicação com o servidor. Tente novamente mais tarde.';
      handleAlertModalError(errorMessage);
    }
  };


  return (
    <Page className="p-3 units-detail" title="Unidades">

      <Header page={"Unidades"} />

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Card className='mb-2 mt-2 p-2'>
        <Row>
          <Col>

            <Button
              className='ms-2 mt-2 mb-2'
              disabled={!permission}
              variant="success"
              onClick={() => { handleOpenCompany() }}
            >
              Visualização do Cliente
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              disabled={!permission}
              variant="success"
              onClick={() => { handleReport() }}
            >
              Relatório de Ativação
            </Button>

          </Col>
        </Row>
      </Card>

      <Forms
        alertMessage={alertMessage}
        fieldChange={handleFieldChange}
        onSubmit={handleSubmit}
        handleAlertModalError={handleAlertModalError}
        units={{
          ...units,
          name: units.name || '',
          cnpj: units.cnpj || '',
          ncontract: units.ncontract || '',
          fone: units.fone || '',
          email: units.email || '',
          password: units.password || '',
          secretOnlyKey: units.secretOnlyKey || '',
          accessSecretOnlyKey: units.accessSecretOnlyKey || '',
          dominioEmail: units.dominioEmail || '',
          address: units.address || '',
          createdAt: units.createdAt || '',
          updatedAt: units.updatedAt || '',
        }}
        permission={permission}
        setEmails={setEmails}
        emails={emails}
        setUnits={setUnits}
        setLocation={updateAddressAndLocation}
        allEmails={allEmails}
        theme={theme}
        linkedCooperatives={linkedCooperatives}
      />

      {equipments?.some(item => item?.serialnumber?.includes("SEMT")) && (
        <AddAlarm
          units={units}
          companyId={_id}
          serialNumber={equipments}
          permission={permission}
          theme={theme}
        />
      )}

      {equipments?.some(item => item?.serialnumber?.includes("SEMT")) && (
        <AddRotation
          units={units}
          companyId={_id}
          serialNumber={equipments}
          permission={permission}
          theme={theme}
        />
      )}

      <Card className='mb-3 mt-3'>
        <Card.Header>
          <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Equipamentos</h5>
        </Card.Header>
        <Card.Body>
          <Row className="align-items-center mb-3">
            <div className={`batch-actions ${selectedEquipments.length > 0 ? 'has-selections' : ''}`}>
              <h6 className={`mt-1 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>
                Ações em lote
                {selectedEquipments.length > 0 && (
                  <span className={`ms-2 badge ${theme === 'dark' ? 'bg-secondary' : 'bg-primary'}`}>
                    {selectedEquipments.length} selecionado{selectedEquipments.length !== 1 ? 's' : ''}
                  </span>
                )}
                {batchActionsLoading && (
                  <span className={`ms-2 small ${theme === 'dark' ? 'text-warning' : 'text-primary'}`}>
                    ⏳ Processando...
                  </span>
                )}
              </h6>

              <div className="mt-2 d-flex flex-wrap gap-2">

                <DropdownButton
                  id="dropdown-scan-face"
                  title="📸 Foto Facial (todos)"
                  variant={theme === 'dark' ? 'outline-light' : 'outline-primary'}
                  disabled={!permission || batchActionsLoading}
                  className={batchActionsLoading ? 'loading' : ''}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title-tooltip="Ativar/Desativar foto facial para todos os equipamentos selecionados"
                >
                  <Dropdown.Item
                    onClick={() => {
                      handleBatchActionRequest('scan_face', true, 'Ativar Foto Facial para todos os equipamentos');
                    }}
                    disabled={batchActionsLoading}
                  >
                    ✅ Ativar Foto Facial
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      handleBatchActionRequest('scan_face', false, 'Desativar Foto Facial para todos os equipamentos');
                    }}
                    disabled={batchActionsLoading}
                  >
                    ❌ Desativar Foto Facial
                  </Dropdown.Item>
                </DropdownButton>

                <DropdownButton
                  id="dropdown-full-tracking"
                  title="🎯 Full Tracking (todos)"
                  variant={theme === 'dark' ? 'outline-light' : 'outline-primary'}
                  disabled={!permission || batchActionsLoading}
                  className={batchActionsLoading ? 'loading' : ''}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title-tooltip="Ativar/Desativar rastreamento completo para todos os equipamentos selecionados"
                >
                  <Dropdown.Item
                    onClick={() => {
                      handleBatchActionRequest('full_tracking', true, 'Ativar Full Tracking para todos os equipamentos');
                    }}
                    disabled={batchActionsLoading}
                  >
                    ✅ Ativar Full Tracking
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      handleBatchActionRequest('full_tracking', false, 'Desativar Full Tracking para todos os equipamentos');
                    }}
                    disabled={batchActionsLoading}
                  >
                    ❌ Desativar Full Tracking
                  </Dropdown.Item>
                </DropdownButton>
              </div>
            </div>
          </Row>

          <Row className='g-2'>
            <Col md={6}>
              <BootstrapMultiSelect
                label={"Equipamentos"}
                options={serialsnumbers}
                selectedEquipments={selectedEquipments}
                setSelectedEquipments={setSelectedEquipments}
              />

              <Button
                className='mt-2'
                disabled={!permission || !selectedEquipments.length}
                variant="success"
                onClick={handleAddEquipments}
              >
                Adicionar Equipamentos
              </Button>

              <Button
                className='mt-2 ms-2'
                disabled={!permission || !selectedEquipments.length}
                variant="outline-danger"
                onClick={handleRemoveEquipments}
              >
                Remover Equipamentos
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {equipments?.some(item => item?.serialnumber?.includes("PRAR")) && (
        <Dryers
          onAddDryer={async (dryerData, positionsData) => {

            // Salvar secador na primeira API
            await saveSecador(dryerData);

            // Salvar posições na segunda API
            await savePositions(positionsData);
          }}
          equipments={equipments}
          permission={permission}
          theme={theme}
        />
      )}

      <Card className='mt-3 mb-3'>
        <Card.Header>
          <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Planos</h5>
        </Card.Header>
        <Card.Body>
          <Row className='g-2'>
            <Col md>
              {rentalEquipments.length > 0 &&
                <div>
                  <h6 className={`mt-1 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Locação</h6>
                  <div className="mt-2 d-flex flex-wrap gap-2">
                    {RENTAL_PLANS.map((plan) => (
                      <Button
                        key={plan.value}
                        disabled={!permission}
                        onClick={() => handlePlanChangeRental(plan.value)}
                        variant="outline-success"
                      >
                        {plan.label}
                      </Button>
                    ))}
                  </div>
                </div>
              }

              {rentalEquipments.length > 0 && ownerEquipments.length > 0 ? <hr /> : null}

              {ownerEquipments.length > 0 &&
                <div>
                  <h6 className={`mt-1 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Proprietário</h6>
                  <div className="mt-2">
                    <Button
                      disabled={!permission}
                      onClick={() => handlePlanChangeOwner('NORMAL')}
                      variant="outline-success"
                    >
                      NORMAL
                    </Button>
                    <Button
                      disabled={!permission}
                      onClick={() => handlePlanChangeOwner('PLUS')}
                      className="ms-2"
                      variant="outline-success"
                    >
                      PLUS
                    </Button>
                    <Button
                      disabled={!permission}
                      onClick={() => handlePlanChangeOwner('FLEX')}
                      className="ms-2"
                      variant="outline-success"
                    >
                      FLEX
                    </Button>
                    <Button
                      disabled={permission === true ? false : true}
                      onClick={() => handlePlanChangeOwner('PREMIUM')}
                      className="ms-2"
                      variant="outline-success"
                    >
                      PREMIUM
                    </Button>
                  </div>
                </div>
              }
            </Col>
          </Row>
        </Card.Body>
      </Card>


      <Card className='mb-3 mt-3'>
        <Card.Header>
          <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Alterar dias de Ativação</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md>
              <FloatingLabel style={{ width: 250 }} controlId="floatingInput" label="Dias" className="mb-3">
                <Form.Control
                  type="number"
                  name="Dias"
                  placeholder="Dias"
                  value={typeof daystoactivate === 'string' ? daystoactivate : (daystoactivate !== undefined && daystoactivate !== null ? String(daystoactivate) : '')}
                  onChange={(event) =>
                    handleDaysChange(event, 'daystoactivate', event.target.value)
                  }
                  disabled={!permission}
                />
              </FloatingLabel>

              <Button
                disabled={!permission}
                onClick={() => {
                  if (!daystoactivate || String(daystoactivate).trim() === '') {
                    handleAlertModalError('O campo dias para Ativação deve ser preenchido!');
                    return;
                  }
                  setShowModelSelectModal(true);
                  setSelectedModels([]);
                }}
                variant="success"
              >
                Alterar
              </Button>
            </Col>
          </Row>

          <hr />

          <Row>
            <Col md>
              <h6 className={`mt-1 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Alterar modo dos equipamentos</h6>

              <Button
                disabled={!permission}
                onClick={() => handleChangeModeAll('RENTAL')}
                variant="success"
              >
                Todos para locação
              </Button>
              <Button
                disabled={!permission}
                onClick={() => handleChangeModeAll('OWNER')}
                className="ms-2"
                variant="success"
              >
                Todos para proprietário
              </Button>
              <Button
                disabled={!permission}
                onClick={() => handleChangeModeAll('ISENTKEY')}
                className="ms-2"
                variant="success"
              >
                Isenção de taxas
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Tabs
        className="mb-3 mt-3"
        activeKey={chave}
        onSelect={(key) => setChave(key)}
      >
        <Tab eventKey="equipamentos" title="EQUIPAMENTOS">
          <>
            <SearchBar
              onSearch={handleSearchEquipments}
              onSearchData={handleSearchData}
              searchData={searchData}
            />

            <div
              style={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: '1rem' }}
              className='mt-3 mb-2'>
              {[
                { key: 'simt', label: 'SIMT' },
                { key: 'semt', label: 'SEMT' },
                { key: 'bitm', label: 'BIMT' },
                { key: 'eemt', label: 'EEMT' },
                { key: 'cpmt', label: 'CPMT' },
                { key: 'esmr', label: 'ESMR' },
                { key: 'fard', label: 'FARD' },
                { key: 'cton', label: 'CTON' },
                { key: 'mufl', label: 'MUFL' },
                { key: 'prar', label: 'PRAR' },
                { key: 'sbag', label: 'SBAG' },
              ].map((item) => (
                <div key={item.key}>
                  <Form.Check
                    isValid
                    type="checkbox"
                    label={item.label}
                    checked={checkbox[item.key]}
                    onChange={(event) => handleCheckBoxdChange(item.key, event.target.checked)}
                  />
                </div>
              ))}
            </div>

            {equipments && equipments.length ? (
              <Equipments
                data={filterData()}
                onRemoveButton={removeEquipment}
                theme={theme}
                permission={permission}
              />
            ) : (
              <h5 className={`${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Nenhum equipamento encontrado.</h5>
            )}
          </>
        </Tab>

        {units && units?.dryer?.length > 0 && (
          <Tab eventKey="secadores" title="SECADORES">
            <>
              {/* <SearchBar
              onSearch={handleSearchUnits}
              onSearchData={handleSearchData}
              searchData={searchData}
            /> */}
              <DryersTable
                data={units.dryer}
                onRemoveButton={removeDryer}
                permission={permission}
                theme={theme}
              />
            </>
          </Tab>
        )}

      </Tabs>

      <Modal show={showModelSelectModal} onHide={() => setShowModelSelectModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Selecionar modelos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Selecione os modelos de equipamentos que deseja alterar os dias de ativação:</p>
          <Form>
            {[...new Set(equipments.map(eq => eq.serialnumber.split('-')[0]))].map(model => (
              <Form.Check
                key={model}
                type="checkbox"
                label={model}
                checked={selectedModels.includes(model)}
                onChange={e => {
                  if (e.target.checked) {
                    setSelectedModels(prev => [...prev, model]);
                  } else {
                    setSelectedModels(prev => prev.filter(m => m !== model));
                  }
                }}
              />
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModelSelectModal(false)}>
            Cancelar
          </Button>
          <Button variant="success" onClick={() => {
            setShowModelSelectModal(false);
            setOpenDialogActivation(true);
          }} disabled={selectedModels.length === 0}>
            Avançar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openDialogActivation} onHide={handleCloseUpdateActivation} centered>
        <Modal.Header closeButton>
          <Modal.Title>Alterar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Confirma alterar os dias de ativação dos equipamentos dos modelos selecionados ({selectedModels.join(', ')}) da{' '}
            <strong>{units.name}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseUpdateActivation}>
            Cancelar
          </Button>
          <Button variant="success" onClick={updateDaysActivation}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openDialogPlanRental} onHide={handleCloseDialogPlan} centered variant="dark">
        <Modal.Header closeButton>
          <Modal.Title>Alterar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Confirma alterar para o plano: <strong>{planRental}</strong> todos os equipamentos desta Unidade?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDialogPlan}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleUpdatePlanChangeRental}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openDialogPlanOwner} onHide={handleCloseDialogPlan} centered variant="dark">
        <Modal.Header closeButton>
          <Modal.Title>Alterar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Confirma alterar para o plano: <strong>{planRental}</strong> todos os equipamentos desta Unidade?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDialogPlan}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleUpdatePlanChangeOwner}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showBatchModal} onHide={handleCancelBatchAction} centered variant="dark">
        <Modal.Header closeButton>
          <Modal.Title>Confirmação de Ação em Lote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Você está prestes a {batchAction.label.toLowerCase()} para todos os equipamentos selecionados.
            <br />
            Tem certeza que deseja continuar?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelBatchAction}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleConfirmBatchAction}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmação para ações em lote */}
      <Modal show={showBatchModal} onHide={handleCancelBatchAction} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Ação em Lote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>{batchAction.label}</strong>
          </p>
          <p>
            Esta ação será aplicada a <strong>todos os equipamentos</strong> da unidade <strong>{units.name}</strong>.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelBatchAction}>
            Cancelar
          </Button>
          <Button
            variant={batchAction.value ? "success" : "danger"}
            onClick={handleConfirmBatchAction}
          >
            {batchAction.value ? "✅ Confirmar Ativação" : "❌ Confirmar Desativação"}
          </Button>
        </Modal.Footer>
      </Modal>

    </Page>
  );
};

export default UnitsDetail;
